import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';

// Older implementations
import { IconComponent } from './components/icon/icon.component';
import { IconsSpriteComponent } from './components/icons-sprite/icons-sprite.component';

// Current implementation
import { IcBaseComponent } from '@app/shared/modules/icons/components/ic/ic-base.component';

// Individual icons
import { IcBellComponent } from '@app/shared/modules/icons/components/ic/ic-bell.component';
import { IcBurgerComponent } from '@app/shared/modules/icons/components/ic/ic-burger.component';
import { IcCloseComponent } from '@app/shared/modules/icons/components/ic/ic-close.component';
import { IcCoinsComponent } from '@app/shared/modules/icons/components/ic/ic-coins.component';
import { IcDropdownArrowComponent } from '@app/shared/modules/icons/components/ic/ic-dropdown-arrow.component';
import { IcGearComponent } from '@app/shared/modules/icons/components/ic/ic-gear.component';
import { IcInfoComponent } from '@app/shared/modules/icons/components/ic/ic-info.component';
import { IcLinkExternalComponent } from '@app/shared/modules/icons/components/ic/ic-link-external.component';
import { IcListComponent } from '@app/shared/modules/icons/components/ic/ic-list.component';
import { IcLogoComponent } from '@app/shared/modules/icons/components/ic/ic-logo.component';
import { IcLogoutComponent } from '@app/shared/modules/icons/components/ic/ic-logout.component';
import { IcMagnifierComponent } from '@app/shared/modules/icons/components/ic/ic-magnifier.component';
import { IcPlusCircleComponent } from '@app/shared/modules/icons/components/ic/ic-plus-circle.component';
import { IcProfileComponent } from '@app/shared/modules/icons/components/ic/ic-profile.component';
import { IcRewardCoinsComponent } from '@app/shared/modules/icons/components/ic/ic-reward-coins.component';
import { IcRewardDueComponent } from '@app/shared/modules/icons/components/ic/ic-reward-due.component';
import { IcSpinnerComponent } from '@app/shared/modules/icons/components/ic/ic-spinner.component';
import { IcStarComponent } from '@app/shared/modules/icons/components/ic/ic-star.component';
import { IcTrophyComponent } from '@app/shared/modules/icons/components/ic/ic-trophy.component';
import { IcPlusCircleOutlinedComponent } from '@app/shared/modules/icons/components/ic/ic-plus-circle-outlined.component';
import { IcLeaderboardCrownComponent } from '@app/shared/modules/icons/components/ic/ic-leaderboard-crown.component';
import { IcArrowDownComponent } from '@app/shared/modules/icons/components/ic/ic-arrow-down.component';
import { IcPlusComponent } from '@app/shared/modules/icons/components/ic/ic-plus.component';
import { IcSwitchComponent } from '@app/shared/modules/icons/components/ic/ic-switch.component';
import { IcWizardWantComponent } from '@app/shared/modules/icons/components/ic/ic-wizard-want.component';
import { IcCalendarComponent } from '@app/shared/modules/icons/components/ic/ic-calendar.component';
import { IcRedoComponent } from '@app/shared/modules/icons/components/ic/ic-redo.component';
import { IcCrossCircleComponent } from './components/ic/ic-cross-circle.component';

@NgModule({
  imports: [CommonModule],
  declarations: [
    // Older implementations
    IconComponent,
    IconsSpriteComponent,
    // Current implementation
    IcBaseComponent,
    // Individual icons
    IcArrowDownComponent,
    IcBellComponent,
    IcBurgerComponent,
    IcCrossCircleComponent,
    IcCloseComponent,
    IcCoinsComponent,
    IcDropdownArrowComponent,
    IcGearComponent,
    IcInfoComponent,
    IcLeaderboardCrownComponent,
    IcLinkExternalComponent,
    IcListComponent,
    IcLogoComponent,
    IcLogoutComponent,
    IcMagnifierComponent,
    IcPlusCircleComponent,
    IcPlusCircleOutlinedComponent,
    IcPlusComponent,
    IcProfileComponent,
    IcRewardCoinsComponent,
    IcRewardDueComponent,
    IcSpinnerComponent,
    IcStarComponent,
    IcSwitchComponent,
    IcTrophyComponent,
    IcWizardWantComponent,
    IcCalendarComponent,
    IcRedoComponent
  ],
  exports: [
    // Older implementations
    IconComponent,
    IconsSpriteComponent,
    // Current implementation
    IcArrowDownComponent,
    IcBellComponent,
    IcBurgerComponent,
    IcCrossCircleComponent,
    IcCloseComponent,
    IcCoinsComponent,
    IcDropdownArrowComponent,
    IcGearComponent,
    IcInfoComponent,
    IcLeaderboardCrownComponent,
    IcLinkExternalComponent,
    IcListComponent,
    IcLogoComponent,
    IcLogoutComponent,
    IcMagnifierComponent,
    IcPlusCircleComponent,
    IcPlusCircleOutlinedComponent,
    IcPlusComponent,
    IcProfileComponent,
    IcRewardCoinsComponent,
    IcRewardDueComponent,
    IcSpinnerComponent,
    IcStarComponent,
    IcSwitchComponent,
    IcSwitchComponent,
    IcTrophyComponent,
    IcWizardWantComponent,
    IcCalendarComponent,
    IcRedoComponent
  ]
})
export class IconsModule {}
